function updateFinialImages(color) {
    if (!color) return;
    const dayVersion = Math.floor(Date.now() / (1000 * 60 * 60 * 24));
    const cdn = 'https://cdn.shopify.com/s/files/1/0752/7399/4425/files/';
    const img = (src) => `<img src="${cdn}${src}" width="130" height="130">`;

    jQuery('input[name="mtsi_runner_type"][value="Pleat Runners"]').siblings('.wpcf7-list-item-label').html(img(`${color}-Pleat-Runners.jpg?v=1${dayVersion}`));
    jQuery('input[name="mtsi_runner_type"][value="S Fold Runners"]').siblings('.wpcf7-list-item-label').html(img(`${color}-S-Fold-Runners.jpg?v=1${dayVersion}`));
    jQuery('input[name="mtsi_mounting_type"][value="Ceiling Mounted"]').siblings('.wpcf7-list-item-label').html(img(`${color}-Ceiling-Mounted.jpg?v=1${dayVersion}`));
    jQuery('input[name="mtsi_mounting_type"][value="Wall Mounted"]').siblings('.wpcf7-list-item-label').html(img(`${color}-Wall-Mounted.jpg?v=1${dayVersion}`));
    jQuery('input[name="mtsi_track_type"][value="Single Track"]').siblings('.wpcf7-list-item-label').html(img(`${color}-Single-Track.jpg?v=1${dayVersion}`));
    jQuery('input[name="mtsi_track_type"][value="Double Track"]').siblings('.wpcf7-list-item-label').html(img(`${color}-Double-Track.jpg?v=1${dayVersion}`));
}

jQuery(document).ready(function ($) {

// =====================
// 货币转换工具
// =====================
const CurrencyUtils = {
  getActive() {
    return window.Shopify?.currency?.active || 'USD';
  },
  getRate() {
    return parseFloat(window.Shopify?.currency?.rate || '1.0');
  },

  // 传入美元金额（非 cents）
  convert(priceInDollars) {
    return priceInDollars * this.getRate();
  },

  format(priceInDollars) {
    const amount = this.convert(priceInDollars);
    const currency = this.getActive();
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 2,
    }).format(amount);
  },
};

// 使用示例
// CurrencyUtils.format(2999)  → "€27.77"（当前货币为 EUR 时）
// CurrencyUtils.getActive()   → "EUR"
// CurrencyUtils.getRate()     → 1.08

// 切换英寸和厘米的按钮动作
document.querySelectorAll('.kg-new').forEach(function(container) {
  const options = container.querySelectorAll('.input-select div');
  const sizeLabels = container.querySelectorAll('.size_width');

options.forEach(function(option) {
  option.addEventListener('click', function() {
    const prevUnit = container.querySelector('.input-select .active').textContent.trim();
    const newUnit = this.textContent.trim(); 

    // 切换 active
    options.forEach(o => o.classList.remove('active'));
    this.classList.add('active');
    sizeLabels.forEach(label => label.textContent = newUnit);

    // 转换已输入的数值
    if (prevUnit !== newUnit) {
      container.querySelectorAll('input[type="number"]').forEach(input => {
        if (input.value) {
          if (newUnit === 'cm') {
            input.value = (parseFloat(input.value) * 2.54).toFixed(2);
          } else {
            input.value = (parseFloat(input.value) / 2.54).toFixed(2);
          }
        }
      });
    }
    handleUpdate(false);
  });
});
});

    // 全局存储用户选项
    let formData = {};

    // 保存初始价格 HTML
    const rawWooPriceHtml = $(".product__price .price .price-item").html();

    const metafieldsJson = document.getElementById("product-metafields");
        let metafields = {};
        if (metafieldsJson) {
            metafields = JSON.parse(metafieldsJson.textContent);
        }  

    // ===== 表单有效性 + 加购拦截（与时序无关）=====
    let formValid = false;

    // 统一入口：设置内部状态 + 视觉禁用
    function setFormValidity(valid) {
        console.log("测试:" + valid);
        formValid = !!valid;
        const $btn = $(".product-form__submit");
        $btn.prop("disabled", !formValid).toggleClass("disabled", !formValid);
    }

    (function setupCartGuard() {
        const SUBMIT_SELECTOR = '.product-form__submit';
        const FORM_SELECTOR = 'product-form form, form[action*="/cart/add"]';

        // 1) 提交拦截：挂在 document 捕获阶段（委托），表单被重渲染也依然生效，且覆盖所有加购表单
        document.addEventListener('submit', function (e) {
            const form = e.target;
            if (form && form.matches && form.matches(FORM_SELECTOR)) {
                if (!formValid) {
                    e.preventDefault();
                    e.stopImmediatePropagation();   // 阻止主题自带的 AJAX 加购
                    alert("Please fill in all required fields!");
                }
            }
        }, true);

        // 2) 视觉自愈：监听整个 body，谁把按钮启用了、而表单还无效，就把【所有】加购按钮禁回去
        let scheduled = false;
        function enforce() {
            scheduled = false;
            if (formValid) return;                  // 表单有效就不干预，交给正常流程
            document.querySelectorAll(SUBMIT_SELECTOR).forEach(function (btn) {
                if (!btn.disabled) {
                    btn.disabled = true;
                    btn.classList.add('disabled');
                }
            });
        }
        new MutationObserver(function () {
            if (scheduled) return;
            scheduled = true;
            requestAnimationFrame(enforce);         // 合并同一帧的多次变动，避免抖动和性能问题
        }).observe(document.body, {
            attributes: true,
            attributeFilter: ['disabled', 'class'],
            childList: true,
            subtree: true
        });
    })();
    // ===== 表单有效性 代码到此结束=====

    /**
     * -------------------------
     * 主函数：更新选项 + 计算价格
     * -------------------------
     */
    function handleUpdate(isFromSplit = false, eventFlag = "") {

        // 每次重新读取选项
        const options = {
            productId: $('input[name="product_id"]').val(),
            variationId: $('input[name="variation_id"]').val() || 0,
            colorName: $("#pa_color-image").val() || "",
            selectedMethod: $('input[name="mtsi_method"]:checked').val(),
            headerType: $('input[name="mtsi_header_type"]:checked').val(),
            width: parseFloat($("#mtsi_custom_curtain_width").val()),
            unit: "inches",
            runnerType: $('input[name="mtsi_runner_type"]:checked').val(),
            panelType: $('input[name="mtsi_panel_type"]:checked').val(),
            openType: $('input[name="mtsi_open_type"]:checked').val(),
            mountingType: $('input[name="mtsi_mounting_type"]:checked').val(),
            trackType: $('input[name="mtsi_track_type"]:checked').val(),
            quantity: parseInt($('.quantity input[name="quantity"]').val() || "1"),
            colorSku: $('.select-option.swatch-wrapper[data-value="' + ($("#pa_color-image").val() || "") + '"]').attr("data-sku") || "",
            linerUnitPrice: parseFloat(metafields.liner_unit_price) || 0,
            fabricUnitPrice: parseFloat(metafields.fabric_unit_price) || 0,
            gramPerSqIn: parseFloat(metafields.gram_per_square_inches) || 0,
            linerGramPerSqIn: parseFloat(metafields.liner_gram_per_square_inches) || 0,
            trackOwen: $('input[name="mtsi_custom_curtain_owen"]').val() || "false",
            patternType: "vertical",
            exchangeRate: parseFloat(1/7.0),
            startValue: "YES"
        };

        formData = options;

        // Split Panels 修复
        if (eventFlag !== "") {
            if (options.panelType === "Split Panels") {
                options.quantity *= 2;
            }
        } else {
            if (options.panelType === "Split Panels") {
                if (2 * options.quantity == 1) {
                    options.quantity *= 2;
                }
            } else if (options.quantity === 1) {
                options.quantity = 1;
                $('input[name="quantity"]').val(options.quantity);
            }
        }

        let curtainWidth  = parseFloat(options.width);   // inch
        const activeUnit = document.querySelector('.input-select .active').textContent.trim();

        if (activeUnit === 'cm') {
        curtainWidth = parseFloat((curtainWidth / 2.54).toFixed(2));
        }
        // 开始计价
        let calculatedPrice = 0;

        let owenRate = 1;
        //判断是track owen的产品时
        if(options.trackOwen === "true"){
            owenRate = 1.2;
        }

        let trackRate = 1;
        
        if (options.trackType === "Double Track") trackRate = 1.6;

        //总价 = （80 + 宽度 * fabricUnitPrice）* 价格系数 * owen系数
        calculatedPrice = (80 + curtainWidth * options.fabricUnitPrice) * trackRate * owenRate;
        //全站价格上涨10%
        //20260521 追加总价*1.5
        calculatedPrice = calculatedPrice * 1.1 * 1.6 * 1.5;
        calculatedPrice = Math.floor(calculatedPrice * 100) / 100;

        options.totalPrice = calculatedPrice;

        //传递数值到隐藏表单，提交到购物车
        
        document.getElementById('hiddenRunnerType').value = options.runnerType ?? '';
        if (activeUnit === 'cm') {
            document.getElementById('hiddenWidth').value = options.width + 'cm' ?? '';
        }else{
            document.getElementById('hiddenWidth').value = options.width + '"' ?? '';
        }
        document.getElementById('hiddenMountingType').value = options.mountingType ?? '';
        document.getElementById('hiddenOpenType').value = options.openType ?? '';
        document.getElementById('hiddenTrackType').value = options.trackType ?? '';
        var appPriceInput = document.getElementById('custom-price-field');

        if (appPriceInput) {
            appPriceInput.value = calculatedPrice;
        }

        // 写入前端显示
        $(".new-xqy .color").html(options.colorSku);
        $(".new-xqy .runnerType").html(options.runnerType);
        $(".new-xqy .openType").html(options.openType);
        $(".new-xqy .mountingType").html(options.mountingType);
        $(".new-xqy .trackType").html(options.trackType);

        if (options.width) {
            if (activeUnit === 'cm') {
                $(".width_height_html").html(options.width + 'cm W');
            }else{
                $(".width_height_html").html(options.width + '"W');
            }
            $(".kuangao").css("border", "none");
        } else {
            $(".width_height_html").html("");
            $(".kuangao").css("border", "1px dashed red");
        }

        // 检查必填项
        validateRequiredFields();

        // 更新价格显示
        if (calculatedPrice) {
            updatePriceDisplay(calculatedPrice, options, options.startValue);
        }
    }

    //初始化加载
    setTimeout(function() {
        const color = $('input[name="Color"]:checked').val();
        updateFinialImages(color);
        handleUpdate(false);
    }, 800);

    /**
     * -------------------------
     * 检查必选项，控制 Add to Cart
     * -------------------------
     */
    function validateRequiredFields() {
        let valid = true;

        if (!formData.openType || !formData.runnerType || !formData.mountingType || !formData.trackType) {
            valid = false;
        }
        if (!formData.width || formData.width <= 1) {
            valid = false;
        }

        setFormValidity(valid); 
    }

    /**
     * -------------------------
     * 更新 WooCommerce 价格显示
     * -------------------------
     */
    function updatePriceDisplay(price, options) {

        const priceBox = $(".product__price .price .price__regular");
        const isOnSale = priceBox.find("del").length > 0 && priceBox.find("ins").length > 0;

        const qty = options.quantity || 1;

        function money(v) {
            return CurrencyUtils.format(v.toFixed(2));
        }

        function buildPriceHtml(_, val) {
            return options.panelType === "Split Panels"
                ? `${qty} × ${money(val)}`
                : `${qty} Piece × ${money(val)}`;
        }

        if (isOnSale) {
            const regular = (parseFloat($("#mtsi_calculated_regular_price_elemnt").data("regular")) || 100);
            const sale = (parseFloat($("#mtsi_calculated_regular_price_elemnt").data("sale")) || 90);
            const regPrice = (regular / sale) * price;

            priceBox.find("del .price-item.price-item--regular").html(money(regPrice));
            priceBox.find("ins .price-item.price-item--regular").html(buildPriceHtml(0, price));

        } else {
            priceBox.find(".price-item.price-item--regular").html(buildPriceHtml(0, price));
        }

        $("#fetch_color_res_txt").html(options.colorName);
        $("#fetch_width_res_txt").html(options.width ? options.width.toFixed(2) + '"' : "");
    }

    /**
     * -------------------------
     * Add to Cart 按钮行为
     * -------------------------
     */
    $(".single_add_to_cart_button").on("click", function (event) {
        event.preventDefault();
        handleUpdate(false);

        if (!formData.runnerType || !formData.mountingType || !formData.openType || !formData.trackType || isNaN(formData.width)) {
            alert("Please fill in all required fields!");
            return;
        }
        if (!formData.colorName) {
            alert("Please choose a color");
            return;
        }

        const requestData = {
            action: "cstm_add_to_cart",
            product_id: formData.productId,
            variation_id: formData.variationId,
            msti_pattern_type: formData.patternType,
            mtsi_color_sku: formData.colorSku,
            mtsi_color_swatch: formData.colorName,
            mtsi_runner_type: formData.runnerType,
            mtsi_open_type: formData.openType,
            mtsi_mounting_type: formData.mountingType,
            mtsi_track_type: formData.trackType,
            mtsi_custom_curtain_width: formData.width,
            mtsi_custom_curtain_unit: formData.unit,
            quantity: formData.quantity,
            calculated_price: formData.totalPrice,
            startValue: formData.startValue,
            security: ajax_object.nonce
        };

        $.ajax({
            url: ajax_object.ajax_url,
            type: "POST",
            data: requestData,
            beforeSend: function () {
                $(".single_add_to_cart_button").prop("disabled", true).addClass("disabled");
            },
            success: function (response) {
                if (response.success) {
                    localStorage.setItem("NEWCARTADDITEM", "1");
                    location.reload();
                } else {
                    alert(response.data.msg);
                    $(".single_add_to_cart_button").prop("disabled", false).removeClass("disabled");
                }
            },
            error: function (_, __, errorMsg) {
                alert("An error occurred: " + errorMsg);
                $(".single_add_to_cart_button").prop("disabled", false).removeClass("disabled");
            }
        });
    });

    /**
     * -------------------------
     * 监听所有选项变化
     * -------------------------
     */
    $('input[name="mtsi_runner_type"], input[name="mtsi_open_type"], input[name="mtsi_mounting_type"], input[name="mtsi_track_type"], #mtsi_custom_curtain_width, .quantity input.quantity__input')
        .on("change", function () {
            handleUpdate(false);
        });

    //变体颜色切换会把价格更改成变体价格，需要等待shopify的更改价格函数执行后，才可以触发更改价格
    $('input[name="Color"]').on("change", function () {    
        const color = $(this).val();
        updateFinialImages(color);    
        setTimeout(() => {
            handleUpdate(false);
        }, 1000);
    });
        
    $("#mtsi_custom_curtain_width").keypress(function (e) {
        if (e.which === 13) e.preventDefault();
        handleUpdate(false);
    });

    $("#mtsi_custom_curtain_width").blur(function () {
        handleUpdate(false);
    });


    /**
     * -------------------------
     * 自动打开 mini-cart（加入购物车后的行为）
     * -------------------------
     */
    let loaded = 0;

    setTimeout(function () {
        if (loaded === 0) {
            loaded = 1;

            if (localStorage.getItem("NEWCARTADDITEM")) {
                $(".lakit-cart__heading-link").click();
                localStorage.removeItem("NEWCARTADDITEM");
            }
        }
    }, 1500);

});